import { render, staticRenderFns } from "./Examen.vue?vue&type=template&id=8c0068ee&scoped=true"
import script from "./Examen.vue?vue&type=script&lang=js"
export * from "./Examen.vue?vue&type=script&lang=js"
import style0 from "./Examen.vue?vue&type=style&index=0&id=8c0068ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0068ee",
  null
  
)

export default component.exports